import { HttpTypes } from "@medusajs/types"

const ORDER_CONFIRMATION_KEY_PREFIX = "plusbake_order_confirmation:"

const isSessionStorageAvailable = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined"

export const storeOrderConfirmation = (order: HttpTypes.StoreOrder) => {
  if (!isSessionStorageAvailable() || !order.id) {
    return
  }

  try {
    window.sessionStorage.setItem(
      `${ORDER_CONFIRMATION_KEY_PREFIX}${order.id}`,
      JSON.stringify(order),
    )
  } catch {
    // Confirmation can still be delivered by email if browser storage is full.
  }
}

export const readOrderConfirmation = (
  orderId: string,
): HttpTypes.StoreOrder | null => {
  if (!isSessionStorageAvailable()) {
    return null
  }

  try {
    const stored = window.sessionStorage.getItem(
      `${ORDER_CONFIRMATION_KEY_PREFIX}${orderId}`,
    )
    if (!stored) {
      return null
    }

    const order = JSON.parse(stored) as Partial<HttpTypes.StoreOrder>
    return order.id === orderId ? (order as HttpTypes.StoreOrder) : null
  } catch {
    return null
  }
}
